/***
 * 创建人：李珊
 * 时间：2020-12-28
 * 描述：知识库管理：分页查询 新增 重命名 删除操作
 * 更新说明:
 */
declare var $;
import { PlatformLocation } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SwMassageConfirmComponent } from 'src/app/librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { SwCreateModalComponentService } from 'src/app/librarys/serves/sw-create-modal-component.service';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { environment } from 'src/environments/environment';
import { KmsService } from '../../../kms.service';
import { KnowledgeBaseAddComponent } from '../knowledge-base-add/knowledge-base-add.component';
import { KnowledgeBaseViewComponent } from '../knowledge-base-view/knowledge-base-view.component';
import { RelatedUserComponent } from '../related-user/related-user.component';

@Component({
  selector: 'app-knowledge-base-query',
  templateUrl: './knowledge-base-query.component.html',
  styleUrls: ['./knowledge-base-query.component.css']
})
export class KnowledgeBaseQueryComponent implements OnInit {
  @ViewChild("swtable") swtable: SwGridTableComponent;
  @ViewChild("trim") trim: SwMassageConfirmComponent;     //确认删除弹框
  // 当前登录用户是否为超级管理员
  isAdmin:boolean = false;
  // 知识库名称
  knowledgebaseName = '';
  // 表格数据
  datas: any = [];
  // 当前选中的数据
  selectedData: any = [];
  // 是否显示加载中
  isLoading: boolean = false;
  // 表格分页组件
  pageBase: any = {
    current: 1,
    size: 10
  }
  // 表格操作按钮
  toolbarArr = [
      ["add"],
      ["modify", "view", "delete", "import"],
  ];
  toolbar = [[], []];
  // 当前登录用户所属组织
  orgId:string = '';
  // 当前登录用户绑定的角色
  userRole:string = '';
  constructor(
    private location: PlatformLocation,
    private jwt: SwJwtService,
    private http: SwHttpClientService,
    private box: SwMassageBoxService,
    private kmsService: KmsService,
    private create: SwCreateModalComponentService
  ) { }

  ngOnInit() {
    this.orgId = this.jwt.getToken('orgId');
    this.userRole = this.jwt.getToken('userRole');
    // 查询工具按钮列表
    this.queryToolbarBtns(); 
    // 表格数据初始化
    this.handleSelectClick();
  }

  // 查询工具按钮列表
  queryToolbarBtns() {
    // 根据路径去查询配置的按钮
    let pathname = ["/", "", ""]
    try {
        pathname = this.location["location"].hash.split('?')[0].split("/");
    } catch (e) {

    }
    let systemId = this.jwt.getToken("systemId")
    // 准备拼接url
    let url = environment.seekerWebAPI + "function/queryButtonsByUri"
    // 要去掉#，故第一个参数不使用
    if (pathname.length > 1) {
        // 拼接uri
        url = url + "?uri=";
        for (let index = 1; index < pathname.length; index++) {
            url = url + "/" + pathname[index]
        }
    }
    // 拼接系统ID参数
    url = url + "&systemId=" + systemId;
    this.http.Post(url, {}).subscribe(data => {
        if (data.code == '200') {
            data.data.forEach((element) => {
                if (
                    this.toolbarArr[0].filter((item) => item == element.functionCode)
                        .length > 0
                ) {
                    this.toolbar[0].push({
                        status: true,
                        functionCode: element.functionCode,
                        functionName: element.functionName,
                        icon: element.icon,
                        children: [],
                    });
                }
                if (
                    this.toolbarArr[1].filter((item) => item == element.functionCode)
                        .length > 0
                ) {
                    this.toolbar[1].push({
                        status: true,
                        functionCode: element.functionCode,
                        functionName: element.functionName,
                        icon: element.icon,
                        children: [],
                    });
                }
            });
        } else {
            this.box.waring('当前用户按钮组权限获取失败！');
        }
    });
  }

  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
      this.handleSelectClick();
    }
  }

  // 查询按钮方法
  handleSelectClick() {
    this.pageBase = {
      current: 1,
      size: 10
    };
    this.getData();
  }

  //获取数据
  getData() {
    this.isLoading = true;
    const params = {
      'orgId': this.userRole == '超级管理员' ? '' : this.orgId,
      'knowledgebaseName': $.trim(this.knowledgebaseName),
      'current': this.pageBase.current,
      'size': this.pageBase.size
    }
    this.kmsService.getknowledgebaseList(params).subscribe(
      data => {
        this.isLoading = false;
        if (data.code == '200') {
          this.pageBase = data.data;
          this.datas = data.data.records;
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  // 按钮点击事件
  handleOperationClick(event) {
    switch (event) {
      case "add": this.handleAddClick(); break; // 新增
      case 'delete': this.handleDeleteClick(); break; // 删除
    }
  }

  // 新增方法
  handleAddClick() {
    let param = { "upOrAdd": "Add", "selectedData": null };
    this.create.createModal(KnowledgeBaseAddComponent, param, this.handleSelectClick.bind(this))
  }

  // 批量删除
  handleDeleteClick() {
    if (this.selectedData.length == 0) {
      this.box.danger('请至少选择一条数据！');
      return;
    }
    let ids = [];
    this.selectedData.forEach(item => {
      ids.push(item.kgDbId);
    });
    this.delete(ids);
  }

  /**
  * 点击td中的按钮
  * @ignore
  */
  clickTdBtn(type, data) {
    //禁止冒泡
    event.stopPropagation();
    // 编辑
    if (type == 'modify') {
      let param = { "upOrAdd": "Edit", "selectedData": data };
      this.create.createModal(KnowledgeBaseAddComponent, param, this.getData.bind(this));
    }
    // 删除
    else if (type == 'delete') {
      this.delete([data.kgDbId]);
    }
    // 导入数据
    else if (type == 'import') {
      
    }
    // // 关联用户
    // else if (type == 'user') {
    //   let param = {"selectedData": data };
    //   this.create.createModal(RelatedUserComponent, param);
    // }
    // 查看
    else if (type == 'view') {
      let param = {"selectedData": data };
      this.create.createModal(KnowledgeBaseViewComponent, param);
    }
    // // 重新创建
    // else if (type == 'reAdd') {
    //   data['createStatus'] = 1;
    //   this.kmsService.saveOrUpdateknowledgebase(data).subscribe(
    //     res => {
    //       if (res["code"] == '200') {
    //         this.box.success("操作成功");
    //         this.handleSelectClick();
    //       }else{
    //         this.box.waring(res.msg);
    //       }
    //     }
    //   )
    // }
  }

  // 表格选中行数据
  handleSelectData(event) {
    //获取当前选中的所有数据
    this.selectedData = event;
    //设置表格按钮组状态
    this.swtable.toolbarAllEnable();
    if (this.selectedData.length == 0) {
      this.swtable.toolbarDisable("delete");
    };
  }

  // 表格分页点击方法
  handlePageClick(event) {
    this.pageBase = event;
    this.getData();
  }

  // 重置数据
  handleReloadClick() {
    this.knowledgebaseName = '';
    this.pageBase = {
      current: 1,
      size: 10
    };
    this.getData();
  }

  // 设置是否上线
  handleOnlineSwitch(value, data){
    data.isOnline = value ? 1 : 0;
    this.kmsService.saveOrUpdateknowledgebase(data).subscribe(
      data => {
        if (data.code == '200') {
          this.box.success('操作成功！');
          this.getData();
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  // 表格列表 是否启用 开关 
  handleEnableSwitch(value, data) {
    if(data.createStatus != 5){
      this.box.waring('当前知识库未创建完成，不允许修改其启用、禁用状态。');
      this.getData();
      return;
    }
    data.baseStatus = value ? 0 : 1;
    this.kmsService.saveOrUpdateknowledgebase(data).subscribe(
      data => {
        if (data.code == '200') {
          this.box.success('操作成功！');
          // 启用或知识库后，需要刷新头部的知识库选项
          this.jwt.setToKen('isRefreshKgDbs','true');
          this.getData();
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  // 删除方法
  delete(ids) {
    this.trim.openCLick("确认删除吗？", (data) => {
      if (data) {
        this.kmsService.deleteknowledgebaseById(ids).subscribe(
          data => {
            if (data["code"] == '200') {
              this.box.success("操作成功");
              this.getData();
              // 删除知识库后，需要刷新头部的知识库选项
              this.jwt.setToKen('isRefreshKgDbs','true');
            } else {
              this.box.waring(data.msg);
            }
          }
        )
      }
    })
  }

  // 获取创建状态名称
  getCreateStatusName(status){
    let str = '';
    switch(status){
      case 1: str = '正在创建知识库';break;
      case 2: str = '正在同步知识库结构';break;
      case 3: str = '正在同步模型数据';break;
      case 4: str = '创建知识库失败';break;
      case 5: str = '创建知识库成功';break;
      default: str = '无';break;
    }
    return str;
  }
}


